module.exports = __webpack_public_path__ + "img/thumb-012.311e43a9.png";